export const Woodlands = {
  id: "woodlands",
  name: "Woodlands Elite - Albany",
  color: "#166534",
  lightColor: "#DCFCE7",
  logo: "🌲",

  teams: [
    { id: "tnt", name: "TNT", level: "L1.1 Tiny - PREP" },
    { id: "majors", name: "Majors", level: "L1.1 Mini - PREP" },
    { id: "crossfire", name: "Crossfire", level: "L1.1 Youth - PREP" },
    { id: "bulletproof", name: "Bulletproof", level: "L1 Youth - Flex" },
    { id: "atomic", name: "Atomic", level: "L3 Junior - Flex" },
    { id: "sabotage", name: "Sabotage", level: "L4.2 Senior" },
    { id: "phantom", name: "Phantom", level: "L2 Youth - Flex - Small" },
    { id: "smoke", name: "Smoke", level: "L2 Junior - Flex" },
    { id: "recon", name: "Recon", level: "L2 Mini" },
  ],

  schedule: [
    // --- SATURDAY ---
    {
      day: "Saturday",
      time: "8:31 AM",
      teamId: "tnt",
      meet: "7:55 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "8:42 AM",
      teamId: "majors",
      meet: "8:06 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "9:41 AM",
      teamId: "crossfire",
      meet: "9:05 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:12 PM",
      teamId: "bulletproof",
      meet: "12:36 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:29 PM",
      teamId: "atomic",
      meet: "1:53 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:26 PM",
      teamId: "sabotage",
      meet: "3:50 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "5:54 PM",
      teamId: "phantom",
      meet: "5:18 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "6:24 PM",
      teamId: "smoke",
      meet: "5:48 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:38 PM",
      teamId: "recon",
      meet: "6:02 PM",
      panel: "Hall A",
    },

    // --- SUNDAY ---
    {
      day: "Sunday",
      time: "9:03 AM",
      teamId: "bulletproof",
      meet: "8:27 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "12:04 PM",
      teamId: "atomic",
      meet: "11:28 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "2:59 PM",
      teamId: "sabotage",
      meet: "2:23 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:08 PM",
      teamId: "phantom",
      meet: "3:32 PM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "4:38 PM",
      teamId: "smoke",
      meet: "4:02 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:52 PM",
      teamId: "recon",
      meet: "4:16 PM",
      panel: "Hall A",
    },
  ],
};
